// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__3GQXg","form":"styles_form__1WyNf"};